import {Injectable} from '@angular/core';
import {Decimal} from 'decimal.js';
import {CurrencyService} from './CurrencyService';
import {ensureCurrencyRate} from '~local/app/shared/objects/Currency';

@Injectable()
export class ExchangeService {

    public constructor(
        private currencyService: CurrencyService
    ) {
    }

    public calculateExchangeRate(amount: number, currencyFrom: string, currencyTo: string, self?: boolean) {
        const rate = ensureCurrencyRate(this.currencyService.currency(currencyFrom), currencyTo).rate;
        const dec = new Decimal(amount);
        let decimalPlaces = 8;

        if (!rate || rate === 0) {
            return 0;
        }

        if (currencyTo === 'EUR') {
            decimalPlaces = 2;
        }

        if (self) {
            return dec.times(rate).toDecimalPlaces(decimalPlaces).toNumber();
        } else {
            return dec.div(rate).toDecimalPlaces(8).toNumber();
        }
    }
}
